module.exports = __webpack_public_path__ + "static/media/anhngu-diem10-tim.24a597c4.png";